/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_3_TitleInputs */

const en_gc_search_guides_gridcraft_online_sections_3_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the online editor does not start`)
};

const zh_gc_search_guides_gridcraft_online_sections_3_title = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在线编辑器无法启动时怎么办`)
};

/**
* | output |
* | --- |
* | "If the online editor does not start" |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_3_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_3_title = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_3_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_3_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_3_title(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_3_title(inputs)
});
export { gc_search_guides_gridcraft_online_sections_3_title as "gc.search_guides.gridcraft_online.sections.3.title" }